import { defineStore } from "pinia";
import productViews from "@/assets/product-views";
import { useBizStore } from "@/store/index.js";

export const useProductPrefStore = defineStore("productPrefStore", {
  state: () => ({
    view: null,
    sortBy: null,
  }),

  getters: {
    get: (state) => (key) => {
      return state[key];
    },
    productView(state) {
      const bizStore = useBizStore();
      const defaultView =
        state.view || bizStore.theme?.defaultProductsView || "list";
      return productViews.find((view) => view.value === defaultView);
    },
  },
  actions: {
    set({ key, value }) {
      this.$state[key] = value;
    },
  },
});
